import { useState } from "react";
import { toast } from "react-toastify";
import Loader from "../../components/Loader"; // Corrected component path
import Calling from "../../api/Calling";
import { useNavigate } from "react-router-dom";

export default function Login({ onLogin }) {
    const [loader, setLoader] = useState(false);
    const [adminId, setAdminId] = useState("");
    const [password, setPassword] = useState("");
    const navigate = useNavigate();

    const handleSubmit = async (e) => {
        try {
            setLoader(true);
            e.preventDefault();
            const body = {
                a_email: adminId,
                a_password: password
            };
            const resp = await Calling.AdminLogin(body);
            const { status, token, message } = resp;
            if (status) {
                toast.success(message, {
                    autoClose: 2000,
                });
                onLogin(true);

                localStorage.setItem('admin_trucaller', token);
                navigate("/", { replace: true }); // Replace with the actual route
            } else {
                toast.error(message, {
                    autoClose: 2000,
                });
                setLoader(false);
            }
        } catch (error) {
            console.log(error);
            setLoader(false);
        }

    };

    return (
        <>
            {loader && <Loader />}

            <div className="min-h-screen flex items-center w-full justify-center back-Img">

                <title>Admin Login</title>
                <div className="bg-main-white p-8 rounded-lg shadow-md w-full max-w-md">
                    <h1 className="text-2xl font-bold text-primary-purple mb-6 text-center">
                        Admin Login
                    </h1>
                    <form onSubmit={handleSubmit}>
                        <div className="mb-4">
                            <label htmlFor="AdminId" className="block text-primary-blue">
                                Admin ID
                            </label>
                            <input
                                type="text"
                                id="AdminId"
                                value={adminId}
                                onChange={(e) => setAdminId(e.target.value)}
                                className="w-full p-2 border border-main-border rounded mt-1 focus:ring-2 focus:ring-main-subfont  focus:outline-none"
                                required
                            />
                        </div>
                        <div className="mb-6">
                            <label htmlFor="password" className=" text-primary-blue">
                                Password
                            </label>
                            {/* <span className="float-right text-primary-blue cursor-pointer" onClick={e => navigate('/admin/panel/forgetpw')}>Forget ?</span> */}
                            <input
                                type="password"
                                id="password"
                                value={password}
                                onChange={(e) => setPassword(e.target.value)}
                                className="w-full p-2 border border-main-border rounded mt-1  focus:ring-2 focus:ring-main-subfont  focus:outline-none"
                                required
                            />
                        </div>
                        <button
                            type="submit"
                            className="w-full bg-primary-blue text-main-white py-2 px-4 rounded hover:bg-primary-purple focus:outline-none focus:ring-2 focus:ring-primary-purple"
                        >
                            Login
                        </button>
                    </form>
                </div>
            </div>
        </>
    );
}
